export const getDiscount = offers => {
	if (!Array.isArray(offers) || offers.length < 2) {
		return null;
	}
	const [best, second] = offers;
	const discount = Math.round((1 - best.total_rate / second.total_rate) * 100);
	return discount >= 20 && discount < 95 ? discount : null;
};
